export default __webpack_public_path__ + "static/trackthebat2-aaded94691386cde674447f8398f68c5.png";